// Angular catches all the exceptions (swallows them!) and just logs them inside console
// https://stackoverflow.com/questions/45827840/application-insights-does-not-track-unhandled-browser-exceptions-in-angular-app

import { ErrorHandler, Injectable } from '@angular/core';

import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private applicationInsightsService: ApplicationInsightsService) {}

  handleError(error: any): void {
    error.message ? console.error(error.message, error) : console.error(error);
    this.applicationInsightsService.logException(error);
  }
}
